<template>
  <div id="maintain">
    <v-toolbar
      class="pt-1 item-dashboard"
      color="grey lighten-4"
      flat
      @click="clickTile($event)"
    >
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu
        :close-on-content-click="false"
        bottom
        full-width
        left
        offset-y
        v-model="dateMenuInstallation"
        v-if="this.by === '4'"
      >
        <v-btn
          color="grey darken-3"
          class="date-range-checked"
          outline
          slot="activator"
          >{{
            new Date(installationRange[0]) | morph-date("DD/MM/YYYY")
          }}
          &mdash;
          {{
            new Date(installationRange[1]) | morph-date("DD/MM/YYYY")
          }}</v-btn
        >
        <v-card>
          <v-card-text>
            <v-date-range
              :labels="installationLabels"
              :options="dateRangeOptions"
              @input="onDateInstallationRangeChange"
              @cancelPicker="cancelPickerInstallation"
              @filterDateRange="filterInstallationDateRange"
            ></v-date-range>
          </v-card-text>
        </v-card>
      </v-menu>
      <v-menu
        :close-on-content-click="false"
        bottom
        full-width
        left
        offset-y
        v-model="dateMenuCompleted"
        v-if="this.by === '4'"
      >
        <v-btn
          color="grey darken-3"
          class="date-range-checked"
          outline
          slot="activator"
          >{{
            new Date(completedRange[0]) | morph-date("DD/MM/YYYY")
          }}
          &mdash;
          {{
            new Date(completedRange[1]) | morph-date("DD/MM/YYYY")
          }}</v-btn
        >
        <v-card>
          <v-card-text>
            <v-date-range
              :labels="completedLabels"
              :options="dateRangeOptions"
              @input="onDateInstallationCompletedRangeChange"
              @cancelPicker="cancelPickerCompleted"
              @filterDateRange="filterCompletedDateRange"
            ></v-date-range>
          </v-card-text>
        </v-card>
        <v-btn
          color="grey darken-3"
          class="date-range-checked"
          outline
          slot="activator"
          @click="download()"
          >Download</v-btn
        >
      </v-menu>
      <v-menu
        :close-on-content-click="false"
        bottom
        full-width
        left
        offset-y
        v-model="dateMenu"
        v-if="this.by !== '4'"
      >
        <v-btn
          color="grey darken-3"
          class="date-range-checked"
          outline
          slot="activator"
          >{{ new Date(range[0]) | morph-date("DD/MM/YYYY") }} &mdash;
          {{ new Date(range[1]) | morph-date("DD/MM/YYYY") }}</v-btn
        >
        <v-card>
          <v-card-text>
            <v-date-range
              :labels="labels"
              :options="dateRangeOptions"
              @input="onDateRangeChange"
              @cancelPicker="cancelPicker"
              @filterDateRange="filterDateRange"
            ></v-date-range>
            <!--<v-layout class="mt-2" row wrap>
                            <v-spacer></v-spacer>
                            <v-btn @click="dateMenu = false" color="primary" flat>Cancel</v-btn>
                            <v-btn @click="filterDateRange()" color="primary" flat>OK</v-btn>
                        </v-layout>-->
          </v-card-text>
        </v-card>
        <v-btn
          color="grey darken-3"
          class="date-range-checked"
          outline
          slot="activator"
          @click="download()"
          v-if="by !== '6'"
          >Download</v-btn
        >
      </v-menu>
      <v-dialog
        content-class="dialog-po"
        max-width="1000px"
        v-model="dialogPdf"
      >
        <v-card>
          <pdf v-for="i in numPages" :key="i" :src="url_pdf" :page="i"></pdf>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-expand-transition>
      <div v-show="expand">
        <v-data-table
          :headers="headers"
          :items="moduleData"
          :loading="loading"
          :pagination.sync="pagination"
          :rows-per-page-items="rowsPerPageItems"
          :total-items="totalItems"
          class="elevation-1"
          item-key="name"
        >
          <template v-slot:headers="props">
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                'column',
                !(typeof header.sortable === 'boolean' && !header.sortable)
                  ? 'sortable'
                  : '',
                header.align ? header.align : 'text-xs-left',
                pagination.descending ? 'desc' : 'asc',
                header.value === pagination.sortBy ? 'active' : '',
              ]"
              @click="changeSort(header)"
            >
              {{ header.text }}
              <v-icon
                small
                v-if="
                  !(typeof header.sortable === 'boolean' && !header.sortable)
                "
                >arrow_upward</v-icon
              >
            </th>
          </template>
          <template slot="items" slot-scope="props">
            <tr
              :active="props.selected"
              @click="props.selected = !props.selected"
              style="color: rgba(0, 0, 0, 0.87) !important"
            >
              <td class="text-xs-left">
                <router-link
                  :to="{
                    name: 'JobDetail',
                    params: { idPO: props.item._id, idJOB: props.item.job_id },
                  }"
                  >{{ props.item.po_number }}</router-link
                >
              </td>
              <td class="text-xs-center" v-if="by !== '6'">
                <router-link
                  :to="{
                    name: 'JobDetail',
                    params: { idPO: props.item._id, idJOB: props.item.job_id },
                  }"
                  >{{ props.item.perform_by }}</router-link
                >
              </td>
              <td
                v-if="by !== '1' && by !== '4' && by !== '6' && by !== '7'"
                class="text-xs-center"
              >
                <router-link
                  :to="{
                    name: 'JobDetail',
                    params: { idPO: props.item._id, idJOB: props.item.job_id },
                  }"
                  >{{
                    props.item.next_maintain_date | morph-date("DD/MM/YYYY")
                  }}</router-link
                >
              </td>
              <td
                v-if="by !== '1' && by !== '4' && by !== '6' && by !== '7'"
                class="text-xs-center"
              >
                <router-link
                  :to="{
                    name: 'JobDetail',
                    params: { idPO: props.item._id, idJOB: props.item.job_id },
                  }"
                  >{{
                    props.item.maintain_expired_date
                      | morph-date("DD/MM/YYYY")
                  }}</router-link
                >
              </td>
              <td
                v-if="by !== '1' && by !== '4' && by !== '6' && by !== '7'"
                class="text-xs-center"
              >
                <router-link
                  :to="{
                    name: 'JobDetail',
                    params: { idPO: props.item._id, idJOB: props.item.job_id },
                  }"
                  >{{
                    props.item.warranty_expired_date
                      | morph-date("DD/MM/YYYY")
                  }}</router-link
                >
              </td>
              <td class="text-xs-center" v-if="by !== '6'">
                <router-link
                  :to="{
                    name: 'JobDetail',
                    params: { idPO: props.item._id, idJOB: props.item.job_id },
                  }"
                  >{{
                    new Date(props.item.execution_date)
                      | morph-date("DD/MM/YYYY")
                  }}</router-link
                >
              </td>
              <td v-if="by === '4' || by === '7'" class="text-xs-center">
                <router-link
                  :to="{
                    name: 'JobDetail',
                    params: { idPO: props.item._id, idJOB: props.item.job_id },
                  }"
                  >{{ props.item.floor }}
                </router-link>
              </td>
              <td v-if="by === '4' || by === '7'" class="text-xs-center">
                <router-link
                  :to="{
                    name: 'JobDetail',
                    params: { idPO: props.item._id, idJOB: props.item.job_id },
                  }"
                  >{{ props.item.localtion }}
                </router-link>
              </td>
              <td v-if="by === '4'" class="text-xs-center">
                <router-link
                  :to="{
                    name: 'JobDetail',
                    params: { idPO: props.item._id, idJOB: props.item.job_id },
                  }"
                  >{{
                    new Date(props.item.time_installation)
                      | morph-date("DD/MM/YYYY")
                  }}
                </router-link>
              </td>
              <td v-if="by === '4'" class="text-xs-center">
                <router-link
                  :to="{
                    name: 'JobDetail',
                    params: { idPO: props.item._id, idJOB: props.item.job_id },
                  }"
                  >{{
                    new Date(props.item.time_completed_installation)
                      | morph-date("DD/MM/YYYY")
                  }}
                </router-link>
              </td>
              <td v-if="by === '7'" class="text-xs-center">
                <router-link
                  :to="{
                    name: 'JobDetail',
                    params: { idPO: props.item._id, idJOB: props.item.job_id },
                  }"
                  >{{
                    new Date(props.item.createdAt)
                      | morph-date("DD/MM/YYYY")
                  }}
                </router-link>
              </td>
              <td v-if="by !== '4' && by !== '6'" class="text-xs-center">
                <router-link
                  :to="{
                    name: 'JobDetail',
                    params: { idPO: props.item._id, idJOB: props.item.job_id },
                  }"
                  >{{ props.item.status }}</router-link
                >
              </td>
              <td v-if="by === '6'" class="text-xs-center">
                <router-link
                  :to="{
                    name: 'JobDetail',
                    params: { idPO: props.item._id, idJOB: props.item.job_id },
                  }"
                  >{{
                    new Date(props.item.createdAt)
                      | morph-date("DD/MM/YYYY")
                  }}
                </router-link>
              </td>
              <td v-if="by === '6'" class="text-xs-center">
                <router-link
                  :to="{
                    name: 'JobDetail',
                    params: { idPO: props.item._id, idJOB: props.item.job_id },
                  }"
                  >{{
                    props.item.job_type === 6 ? "Preliminary" : "Acceptance"
                  }}
                </router-link>
              </td>
              <td v-if="by === '6'" class="text-xs-center">
                <span
                  class="cursor_pdf"
                  @click="previewPdf(props.item.url_job)"
                >
                  {{ props.item.url_job }}
                </span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import PurchaseOrderService from "../services/purchase.order.service.js";
import {
  format,
  subDays,
  startOfDay,
  endOfDay,
  startOfToday,
  endOfToday,
  startOfYesterday,
  endOfYesterday,
  startOfWeek,
  startOfMonth,
  lastDayOfMonth,
} from "date-fns";
import * as _ from "lodash";
import * as json2csv from "json2csv";
import RepairReasonService from "../services/repair.reason.service";
// import { isEmpty } from "lodash";
import VDateRange from "./DateRange.vue";
import { extraTaskConst } from "../common/Constants.js";
import pdf from "vue-pdf";

export default {
  data() {
    let headers = [
      {
        text: "PO Number",
        value: "po_number",
      },
      {
        text: "Performed By",
        value: "perform_by",
        align: "text-xs-center",
      },
      {
        text: "Next Maintain Date",
        value: "next_maintain_date",
        align: "text-xs-center",
      },
      {
        text: "Maintain Expired Date",
        value: "maintain_expired_date",
        align: "text-xs-center",
      },
      {
        text: "Warranty Expired Date",
        value: "warranty_expired_date",
        align: "text-xs-center",
      },
      {
        text: "Execution Date",
        value: "createdAt",
        align: "text-xs-center",
      },
      {
        text: "Job's status",
        value: "status",
        align: "text-xs-center",
      },
    ];
    if (this.by === "1") {
      headers = [
        {
          text: "PO Number",
          value: "po_number",
        },
        {
          text: "Performed By",
          value: "performBy",
          align: "text-xs-center",
        },
        {
          text: "Execution Date",
          value: "createdAt",
          align: "text-xs-center",
        },
        {
          text: "Job's status",
          value: "status",
          align: "text-xs-center",
        },
      ];
    }
    if (this.by === "7") {
      headers = [
        {
          text: "PO Number",
          value: "po_number",
        },
        {
          text: "Performed By",
          value: "performBy",
          align: "text-xs-center",
        },
        {
          text: "Execution Date",
          value: "execution_date",
          align: "text-xs-center",
        },
        {
          text: "Floor",
          value: "floor",
          align: "text-xs-center",
        },
        {
          text: "location",
          value: "localtion",
          align: "text-xs-center",
        },
        {
          text: "Create Date",
          value: "createdAt",
          align: "text-xs-center",
        },
      ];
    }
    if (this.by === "4") {
      headers = [
        {
          text: "PO Number",
          value: "po_number",
        },
        {
          text: "Performed By",
          value: "perform_by",
          align: "text-xs-center",
        },
        {
          text: "Execution Date",
          value: "createdAt",
          align: "text-xs-center",
        },
        {
          text: "Floor",
          value: "floor",
          align: "text-xs-center",
        },
        {
          text: "Localtion",
          value: "localtion",
          align: "text-xs-center",
        },
        {
          text: "Time Installation",
          value: "time_installation",
          align: "text-xs-center",
        },
        {
          text: "Time Completed Installation",
          value: "time_completed_installation",
          align: "text-xs-center",
        },
      ];
    }
    if (this.by === "6") {
      headers = [
        {
          text: "PO Number",
          value: "po_number",
        },
        {
          text: "Date",
          value: "createdAt",
          align: "text-xs-center",
        },
        {
          text: "Handover Form",
          value: "job_type",
          align: "text-xs-center",
        },
        {
          text: "File",
          value: "url_job",
          align: "text-xs-center",
        },
      ];
    }
    return {
      expand: true,
      pagination: {
        rowsPerPage: 5,
        sortBy: "updatedAt",
        descending: true,
        totalItems: 0,
        page: 1,
      },
      url_pdf: "",
      numPages: undefined,
      dialogPdf: false,
      dateMenu: false,
      dateMenuInstallation: false,
      dateMenuCompleted: false,
      range: [],
      installationRange: [],
      completedRange: [],
      labels: {
        start: "From Execution Date",
        end: "To Execution Date",
      },
      installationLabels: {
        start: "From Installation Date",
        end: "To Installation Date",
      },
      completedLabels: {
        start: "From Installation Completed Date",
        end: "To Installation Completed Date",
      },
      totalItems: 0,
      rowsPerPageItems: [5, 10, 25],
      pickerFrom: false,
      pickerTo: false,

      dateRangeOptions: {
        startDate: format(subDays(new Date(), 7), "YYYY-MM-DD"),
        endDate: format(new Date(), "YYYY-MM-DD"),
        format: "DD/MM/YYYY",
        maxDate: format(subDays(new Date(), -730), "YYYY-MM-DD"),
        presets: [
          {
            label: "Today",
            range: [
              format(startOfToday(), "YYYY-MM-DD"),
              format(endOfToday(), "YYYY-MM-DD"),
            ],
          },
          {
            label: "Yesterday",
            range: [
              format(startOfYesterday(), "YYYY-MM-DD"),
              format(endOfYesterday(), "YYYY-MM-DD"),
            ],
          },
          {
            label: "Last Week",
            range: [
              format(
                subDays(
                  startOfWeek(new Date(), {
                    weekStartsOn: 1,
                  }),
                  7
                ),
                "YYYY-MM-DD"
              ),
              format(
                subDays(
                  startOfWeek(new Date(), {
                    weekStartsOn: 1,
                  }),
                  1
                ),
                "YYYY-MM-DD"
              ),
            ],
          },
          {
            label: "Last Month",
            range: [
              format(
                startOfMonth(new Date().setMonth(new Date().getMonth() - 1)),
                "YYYY-MM-DD"
              ),
              format(
                lastDayOfMonth(new Date().setMonth(new Date().getMonth() - 1)),
                "YYYY-MM-DD"
              ),
            ],
          },
        ],
      },
      purchaseOrderService: new PurchaseOrderService(),
      sortBy: "",

      loading: false,
      headers,
      moduleData: [],
      repairReasonService: new RepairReasonService(),
      listRepairReasons: [],
    };
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    by: {
      type: String,
      required: true,
    },
    future: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    if (this.future) {
      this.installationRange =
        this.completedRange =
        this.range =
          [
            format(new Date(), "YYYY-MM-DD"),
            format(subDays(new Date(), -14), "YYYY-MM-DD"),
          ];
    } else {
      this.installationRange =
        this.completedRange =
        this.range =
          [
            format(subDays(new Date(), 7), "YYYY-MM-DD"),
            format(new Date(), "YYYY-MM-DD"),
          ];
    }
    this.rangTemp = this.range;
    this.getData();
    this.getListRepairReasons();
  },
  mounted() {},
  watch: {
    pagination: {
      handler(oldValue, newValue) {
        if (oldValue.descending !== newValue.descending)
          this.pagination.page = 1;
        if (!_.isEqual(oldValue, newValue)) this.getData();
      },
      deep: true,
    },
  },
  components: {
    VDateRange,
    pdf,
  },
  methods: {
    getListRepairReasons() {
      this.repairReasonService
        .getRepairReasons()
        .then((data) => (this.listRepairReasons = data));
    },
    getRepairReason(id) {
      if (this.listRepairReasons && this.listRepairReasons.length) {
        return this.listRepairReasons.find((r) => r.id === id).name || id;
      }
      return id;
    },
    changeSort(data) {
      if (typeof data.sortable === "boolean" && !data.sortable) return;
      const column = data.value;
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
      this.pagination.page = 1;
      this.getData();
    },
    getData() {
      this.loading = true;
      let params = {
        page: this.pagination.page,
        limit: this.pagination.rowsPerPage,
      };

      if (this.by == "4") {
        params = {
          ...params,
          installationFrom: format(
            startOfDay(new Date(this.installationRange[0])),
            "YYYY-MM-DDTHH:mm:ss"
          ),
          installationTo: format(
            endOfDay(new Date(this.installationRange[1])),
            "YYYY-MM-DDTHH:mm:ss"
          ),
          completedFrom: format(
            startOfDay(new Date(this.completedRange[0])),
            "YYYY-MM-DDTHH:mm:ss"
          ),
          completedTo: format(
            endOfDay(new Date(this.completedRange[1])),
            "YYYY-MM-DDTHH:mm:ss"
          ),
        };
      } else {
        params = {
          ...params,
          from: format(
            startOfDay(new Date(this.range[0])),
            "YYYY-MM-DDTHH:mm:ss"
          ),
          to: format(endOfDay(new Date(this.range[1])), "YYYY-MM-DDTHH:mm:ss"),
        };
      }

      let filter_date_by = "";
      switch (this.by) {
        case "1":
          filter_date_by = "site_check";
          break;
        case "3":
          filter_date_by = "repaired";
          break;
        case "2":
          filter_date_by = "maintained";
          break;
        case "4":
          filter_date_by = "installation";
          break;
        case "6":
          filter_date_by = "preliminary_handover_and_acceptance";
          break;
        case "7":
          filter_date_by = "safety_assessment";
          break;
      }
      params.filter_date_by = filter_date_by;
      if (this.pagination.sortBy) {
        params.sort =
          (this.pagination.descending ? "-" : "") + this.pagination.sortBy;
      }

      this.purchaseOrderService.getList(params).then((res) => {
        this.moduleData = res.docs;
        this.loading = false;
        this.totalItems = res.total;
      });
    },
    downloadData() {
      this.loading = true;
      let params;
      if (this.by == "4") {
        params = {
          installationFrom: format(
            startOfDay(new Date(this.installationRange[0])),
            "YYYY-MM-DDTHH:mm:ss"
          ),
          installationTo: format(
            endOfDay(new Date(this.installationRange[1])),
            "YYYY-MM-DDTHH:mm:ss"
          ),
          completedFrom: format(
            startOfDay(new Date(this.completedRange[0])),
            "YYYY-MM-DDTHH:mm:ss"
          ),
          completedTo: format(
            endOfDay(new Date(this.completedRange[1])),
            "YYYY-MM-DDTHH:mm:ss"
          ),
        };
      } else {
        params = {
          from: format(
            startOfDay(new Date(this.range[0])),
            "YYYY-MM-DDTHH:mm:ss"
          ),
          to: format(endOfDay(new Date(this.range[1])), "YYYY-MM-DDTHH:mm:ss"),
        };
      }

      let filter_date_by = "";
      switch (this.by) {
        case "1":
          filter_date_by = "site_check";
          break;
        case "3":
          filter_date_by = "repaired";
          break;
        case "2":
          filter_date_by = "maintained";
          break;
        case "4":
          filter_date_by = "installation";
          break;
        case "6":
          filter_date_by = "preliminary_handover_and_acceptance";
          break;
        case "7":
          filter_date_by = "safety_assessment";
          break;
      }
      params.filter_date_by = filter_date_by;

      if (this.pagination.sortBy) {
        params.sort =
          (this.pagination.descending ? "-" : "") + this.pagination.sortBy;
      }

      this.purchaseOrderService.getAllList(params).then((res) => {
        this.loading = false;
        let arrData = [];
        let fileName = "";
        switch (this.by) {
          case "1":
            fileName = "site_check_job";
            arrData = res.map((doc) => {
              return {
                "PO Number": doc.po_number,
                "Perform By": doc.perform_by,
                "Execution Date": format(
                  new Date(doc.execution_date),
                  "DD/MM/YYYY"
                ),
                Status: doc.status,
              };
            });
            break;
          case "3":
            fileName = "repaired_job";
            arrData = res.map((doc) => {
              let replaced_spare_parts = "";
              if (
                doc.replaced_spare_parts &&
                doc.replaced_spare_parts.length > 0
              ) {
                replaced_spare_parts = doc.replaced_spare_parts
                  .map(
                    (e) =>
                      e.replaced_spare_part +
                      " x " +
                      e.replace_spare_part_qty +
                      " = " +
                      e.sub_total_amount.toLocaleString() +
                      " VNĐ"
                  )
                  .join(", ");
              }

              let extra_task_repair_items = "";
              if (
                doc.extra_task_repair_items &&
                doc.extra_task_repair_items.length
              ) {
                const extra_task_repair_item_names =
                  doc.extra_task_repair_items.map((e) => e.name);
                extra_task_repair_items =
                  extra_task_repair_item_names.join(", ");
              }

              let total_amount = "";
              if (doc.total_amount) {
                total_amount = doc.total_amount.toLocaleString() + " VNĐ";
              }
              const payment_method = doc.payment_method
                ? doc.payment_method.name
                : "";

              return {
                "PO Number": doc.po_number,
                "Perform By": doc.perform_by,
                "Execution Date": format(
                  new Date(doc.execution_date),
                  "DD/MM/YYYY"
                ),
                "Warranty Expire Date": format(
                  new Date(doc.warranty_expired_date),
                  "DD/MM/YYYY"
                ),
                "Repair Reason": this.getRepairReason(doc.repair_reason),
                "Repair Item": doc.repair_item && doc.repair_item.join(),
                "Replaced Spare Part":
                  doc.replaced_spare_part && doc.replaced_spare_part.join(),
                "Repair Work": doc.repair_work,
                Effort: doc.effort,
                "Extra task no of assignee": doc.extra_task_no_of_assignee,
                "Extra task repair items": extra_task_repair_items,
                "Replaced spare parts": replaced_spare_parts,
                "Total amount": total_amount,
                "Payment method": payment_method,
                Status: doc.status,
                Rate: doc.zalo_rate
              };
            });
            break;
          case "2":
            fileName = "maintained_job";
            arrData = res.map((doc) => {
              let replaced_spare_parts = "";
              if (
                doc.replaced_spare_parts &&
                doc.replaced_spare_parts.length > 0
              ) {
                replaced_spare_parts = doc.replaced_spare_parts
                  .map(
                    (e) =>
                      e.replaced_spare_part +
                      " x " +
                      e.replace_spare_part_qty +
                      " = " +
                      e.sub_total_amount.toLocaleString() +
                      " VNĐ"
                  )
                  .join(", ");
              }

              let total_amount = "";
              if (doc.total_amount) {
                total_amount = doc.total_amount.toLocaleString() + " VNĐ";
              }

              let extra_tasks = "";
              if (doc.extra_tasks && doc.extra_tasks.length) {
                let extra_task_names = doc.extra_tasks.map((e) => e.name);
                const index = extra_task_names.indexOf(extraTaskConst.Khac);
                if (index !== -1) {
                  extra_task_names[index] += ": " + doc.extra_task_detail;
                }
                extra_tasks = extra_task_names.join(", ");
              }

              let extra_task_repair_reasons = "";
              if (
                doc.extra_task_repair_reasons &&
                doc.extra_task_repair_reasons.length
              ) {
                const extra_task_repair_reason_names =
                  doc.extra_task_repair_reasons.map((e) => e.name);
                const index = extra_task_repair_reason_names.indexOf(
                  extraTaskConst.Khac
                );
                if (index !== -1) {
                  extra_task_repair_reason_names[index] +=
                    ": " + doc.extra_task_repair_reason_detail;
                }
                extra_task_repair_reasons =
                  extra_task_repair_reason_names.join(", ");
              }

              let extra_task_repair_items = "";
              if (
                doc.extra_task_repair_items &&
                doc.extra_task_repair_items.length
              ) {
                const extra_task_repair_item_names =
                  doc.extra_task_repair_items.map((e) => e.name);
                extra_task_repair_items =
                  extra_task_repair_item_names.join(", ");
              }

              const payment_method = doc.payment_method
                ? doc.payment_method.name
                : "";
              return {
                "PO Number": doc.po_number,
                "Perform By": doc.perform_by,
                "Execution Date": format(
                  new Date(doc.execution_date),
                  "DD/MM/YYYY"
                ),
                "Number of periodic maintenance": doc.is_new_data
                  ? doc.form_free_maintenance.periodic_maintenance
                  : doc.periodic_maintenance,
                "Number of remaining periodic maintenance": doc.is_new_data
                  ? doc.form_free_maintenance.remaining_periodic_maintenance
                  : doc.remaining_periodic_maintenance,
                "Number of charged maintenance":
                  doc.form_chargeable_maintenance.periodic_maintenance,
                "Number of remaining charged maintenance":
                  doc.form_chargeable_maintenance
                    .remaining_periodic_maintenance,
                Status: doc.status,
                "Start time": doc.start_time,
                "End time": doc.end_time,
                "No of assignee": doc.no_of_assignee,
                Effort: doc.effort,
                "Extra tasks": extra_tasks,
                "Extra task start time": doc.extra_task_start_time,
                "Extra task end time": doc.extra_task_end_time,
                "Extra task no of assignee": doc.extra_task_no_of_assignee,
                "Extra task repair items": extra_task_repair_items,
                "Extra task repair reasons": extra_task_repair_reasons,
                "Extra task description": doc.extra_task_description,
                "Replaced spare parts": replaced_spare_parts,
                "Total amount": total_amount,
                "Payment method": payment_method,
                Rate: doc.zalo_rate
              };
            });
            break;
          case "4":
            fileName = "installation_job";
            arrData = res.map((doc) => {
              return {
                "PO Number": doc.po_number,
                "Perform By": doc.perform_by,
                "Execution Date": format(
                  new Date(doc.execution_date),
                  "DD/MM/YYYY"
                ),
                Floor: doc.floor,
                Localtion: doc.localtion,
                "Time Installation": format(
                  new Date(doc.time_installation),
                  "DD/MM/YYYY"
                ),
                "Time Completed Installation": format(
                  new Date(doc.time_completed_installation),
                  "DD/MM/YYYY"
                ),
              };
            });
            break;
          case "6":
            fileName = "Handover/Preliminary_job";
            arrData = res.map((doc) => {
              return {
                "PO Number": doc.po_number,
                "Acceptance Record Date": format(
                  new Date(doc.createdAt),
                  "DD/MM/YYYY"
                ),
                Handover: doc.job_type,
                File: doc.url_job,
              };
            });
            break;
          case "7":
            fileName = "safety_assessment_job";
            arrData = res.map((doc) => {
              return {
                "PO Number": doc.po_number,
                "Perform By": doc.email,
                "Execution Date": format(
                  new Date(doc.latest_maintain_date),
                  "DD/MM/YYYY"
                ),
                Floor: doc.floor,
                Location: doc.localtion,
                "Create Date": format(new Date(doc.createdAt), "DD/MM/YYYY"),
              };
            });
            break;
        }
        const csvContent =
          "data:text/csv; charset=utf-8," +
          encodeURIComponent("\uFEFF" + json2csv.parse(arrData));

        const link = document.createElement("a");
        link.setAttribute("href", csvContent);
        link.setAttribute("download", `${fileName}.csv`);
        link.click();
      });
    },
    onDateRangeChange(range) {
      this.rangTemp = range;
    },
    onDateInstallationRangeChange(installationRange) {
      this.rangTemp = installationRange;
    },
    onDateInstallationCompletedRangeChange(completedRange) {
      this.rangTemp = completedRange;
    },
    filterDateRange() {
      this.range = this.rangTemp;
      this.from = this.rangTemp[0];
      this.to = this.rangTemp[1];
      this.dateMenu = false;
      this.getData();
    },
    filterInstallationDateRange() {
      this.installationRange = this.rangTemp;
      this.from = this.rangTemp[0];
      this.to = this.rangTemp[1];
      this.dateMenuInstallation = false;
      this.getData();
    },
    filterCompletedDateRange() {
      this.completedRange = this.rangTemp;
      this.from = this.rangTemp[0];
      this.to = this.rangTemp[1];
      this.dateMenuCompleted = false;
      this.getData();
    },
    download() {
      this.range = this.rangTemp;
      this.from = this.rangTemp[0];
      this.to = this.rangTemp[1];
      this.dateMenu = true;
      if (this.by === "4") {
        this.dateMenuCompleted = true;
      }
      this.downloadData();
    },
    clickTile(e) {
      const t = e.target.classList.value;
      if (
        t === "v-toolbar__content" ||
        t === "v-toolbar__title" ||
        !this.expand
      ) {
        this.expand = !this.expand;
      }
    },
    cancelPicker() {
      this.dateMenu = false;
      this.range[0] = this.dateRangeOptions.startDate;
      this.range[1] = this.dateRangeOptions.endDate;
    },
    cancelPickerCompleted() {
      this.dateMenuCompleted = false;
      this.range[0] = this.dateRangeOptions.startDate;
      this.range[1] = this.dateRangeOptions.endDate;
    },
    cancelPickerInstallation() {
      this.dateMenuInstallation = false;
      this.range[0] = this.dateRangeOptions.startDate;
      this.range[1] = this.dateRangeOptions.endDate;
    },
    previewPdf(item) {
      this.url_pdf = pdf.createLoadingTask(item);
      this.url_pdf.promise.then((pdf) => {
        this.numPages = pdf.numPages;
      });
      this.dialogPdf = true;
    },
  },
};
</script>

<style>
#maintain .v-toolbar__title {
  font-size: 16px;
}

#maintain .date-range-checked {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.item-dashboard {
  cursor: pointer;
}

.cursor_pdf {
  cursor: pointer;
}
</style>
